import React from 'react';
import { WithStylesProps } from 'react-jss';

import { EM_DASH } from '~/common/constants/unicode';
import FieldValuesSingleSelect from '~/components/Shared/FieldValuesSingleSelect/FieldValuesSingleSelect';

import styles from '../InformationField.styles';
import { Field } from '../InformationFieldV2';

interface SingleArrayFieldProps extends WithStylesProps<typeof styles> {
  field: Field;
  editMode: boolean;
  fieldValue: any;
  setFieldValue: (value: any) => void;
}

export const SingleArrayField = ({
  classes,
  field,
  editMode,
  fieldValue,
  setFieldValue,
}: SingleArrayFieldProps) => {
  if (editMode) {
    const presentValue = fieldValue
      ? { label: fieldValue.display_value, value: fieldValue.value }
      : null;

    return (
      <div className={classes.editItemContainer}>
        <FieldValuesSingleSelect
          aria-label={field.name}
          defaultValue={presentValue}
          onChange={(newValue: any) => {
            const newState = newValue ? newValue.value : newValue;
            setFieldValue({ display_value: newState, value: newState });
          }}
          isDisabled={!field.is_editable}
          isClearable={field.is_nullable}
          isCreatable={field.allow_new_options}
          fieldId={field.id}
          fieldValues={field.values}
        />
      </div>
    );
  }

  return fieldValue ? fieldValue.display_value : EM_DASH;
};
